<!-- <nb-card>
    <nb-card-header>Pop-up Blocked</nb-card-header>
    <nb-card-body>
      Pop-ups are blocked for this website. Please enable pop-ups in your browser settings.
    </nb-card-body>
    <nb-card-footer>
      <button nbButton status="primary" (click)="close()">Close</button>
    </nb-card-footer>
  </nb-card> -->
  <!-- <div>
    Pop-ups are blocked for this website. Please enable pop-ups in your browser settings.
  </div> -->
  <div class="modal-overlay dialog-card"></div>
    <div class="modal-content">
      <div class="header">Alert</div>
      <div class="message">It looks like your browser has blocked the pop-ups for MyLTTS. Please enable pop-ups for the MyLTTS site in your browser settings to proceed.</div>
      <div class="action">
        <button (click)="closeModal()">Close</button>
      </div>
    </div>